import React from 'react';
import './section7.css'
import Title from '../common/title';
import Btn from '../common/btn';

import Text from '../common/text';
const Sec7 = () => {
    return (<>
    <section className='sec7'>
 <Title title='Find a Home Now' t='title' />
            <Text text=' Ready to make Golden Hills Apartments your new home? Contact us today to schedule a tour or explore available units. Our team is here to help you find the perfect apartment that fits your lifestyle and needs.' x='text'  />
    <article className='sec7-div'>
        <Btn btn='Read More' />
<Btn btn='Book Now' />
<Btn btn='Contact  Us' />

    </article>
    </section>
    </>  );
}
 
export default Sec7;